export enum CreatePasswordActionsType {
  CREATE_PASSWORD_INPUT = 'CREATE_PASSWORD_INPUT',
  CREATE_PASSWORD_SUBMIT = 'CREATE_PASSWORD_SUBMIT',
  SHOW_PASSWORD = 'SHOW_PASSWORD',
  RESET_STATE = 'CREATE_PASSWORD_RESET_STATE',
}

interface CreatePasswordInputAction {
  type: CreatePasswordActionsType.CREATE_PASSWORD_INPUT;
  payload: string;
}

interface ShowPasswordAction {
  type: CreatePasswordActionsType.SHOW_PASSWORD;
}

interface CreatePasswordSubmitAction {
  type: CreatePasswordActionsType.CREATE_PASSWORD_SUBMIT;
  isValid: boolean;
  errorMessage: string;
}

interface CreatePasswordResetStateAction {
  type: CreatePasswordActionsType.RESET_STATE;
}

export function setPassword(payload: string): CreatePasswordInputAction {
  return {
    type: CreatePasswordActionsType.CREATE_PASSWORD_INPUT,
    payload,
  };
}

export function setShowPassword(): ShowPasswordAction {
  return {
    type: CreatePasswordActionsType.SHOW_PASSWORD,
  };
}

export function setPasswordSubmit(isValid: boolean, errorMessage: string): CreatePasswordSubmitAction {
  return {
    type: CreatePasswordActionsType.CREATE_PASSWORD_SUBMIT,
    isValid,
    errorMessage,
  };
}

export function resetState(): CreatePasswordResetStateAction {
  return {
    type: CreatePasswordActionsType.RESET_STATE,
  };
}

export type CreatePasswordActions =
  | CreatePasswordInputAction
  | ShowPasswordAction
  | CreatePasswordSubmitAction
  | CreatePasswordResetStateAction;
